// Quiz module

var service = require('./../QuizService');
var spotify = require('./../SpotifyService');
var $ = require('jquery');

module.exports = {
    template: require('./template.html'),
    replace: false,
    data: function () {
        return {
            audio: null,
            questions: [

            ],
            totalTime: 0,
          //  questionStartTime: null,
          //  questionEndTime: null,
            currentQuestion: 0,
            currentBundleQuestion: 0,
            correctAnswers: 0,
            resultProcent: 0,
            questionAnswered: false,
            view: 'setup',
            quizStart: false,
            continueApplication: false,
            currentQuestionTime: null,
            timesUp: false,
            running: false,
            startTime: null,
            currentTime: null,
            showRightAnswer: false,
            badge: null,
            singleBool: false,
            resultText: 0,
            checkedNonAnswer: true,
            quizId: service.getId(),
            answeredModelusQuestion: false,
            dan: false,
            randomNr: 0
        };
    },
    computed: {

        elapsed: function () {
            if (!this.startTime || !this.currentTime) {
                return null;
            }

            var elapsed = this.currentTime.getTime() - this.startTime.getTime();

            if(elapsed >= 15000) {
                this.running = false;

                if(this.checkedNonAnswer) {
                    this.checkedNonAnswer = false;
                    this.answer('timesUp');
                }

                elapsed = 15000;

            }

            return elapsed;
        },

        question: function () {
            return this.questions[this.currentQuestion];
        }

    },
    methods: {

        quizShare: function() {

            shareFace(service.getId());

        },

        quizShareLinkedin: function () {

            shareLinkedIn(service.getId());

        },


        tweetShareQuiz: function () {


            ga('send', 'event', 'Share', 'click', 'Twitter Quiz');

            var loc = 'https://thejob.filtr.com';
            var title  = encodeURIComponent('Do you think you have what it takes? #TheJobByFiltr');
            window.open('http://twitter.com/share?url=' + loc + '&text=' + title + '&', 'twitterwindow', 'height=450, width=550, top='+($(window).height()/2 - 225) +', left='+$(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');


        },

        render: function () {
            this.currentTime = new Date();

            if (this.running) {
                requestAnimationFrame(this.render);
            }
        },

        startTimer: function (duration) {
            this.startTime = new Date();
            this.currentTime = this.startTime;

            this.running = true;
            this.render();

        },

        nextQuestion: function () {

            if(!this.questionAnswered) {
                return;
            }

            $('#quizAnimate').animate({right:'-250px'},500);

            var self = this;

            if(this.question.type == 'followup') {

                $('.quizwave').animate({
                    left: "-=30%",
                }, 500, function() {
                });
            }

            if(this.question.type == 'audio') {

                $('.animateQuiz').animate({
                    opacity: 1
                }, 500, function() {
                    self.startTimer();
                });
            } else {
                self.startTimer();
            }

            this.singleBool = false;

            if(this.currentQuestion < 19) {
                if(this.question.type == 'followup') {
                    this.playSong();
                    this.currentBundleQuestion++;
                }
            } else {
                this.view = 'quizFinish';

                this.stopSong();

                this.randomNr = Math.floor(Math.random() * 4) + 1;
                var getProcent = this.calcProcent(this.correctAnswers);

                var resPro = getProcent + this.randomNr;

                this.resultProcent = Math.floor(resPro);

                setTimeout(function() {
                    $('#continueBtnQuizAnimate').animate({right:'6%'},500);
                },100);


                if(this.resultProcent <= 40) {


                    this.continueApplication = false;
                    this.badge = 'tunedeaf';

                    if(this.resultProcent < 5) {
                        this.resultProcent = 0;
                    }

                    ga('send', 'event', 'Quiz View Badges', 'click', 'tunedeaf');

                    var text = [
                        'Wait, what!? Were you asleep while doing this test? You probably think that Major Lazer is a hair removal clinic and that The Weeknd is just something you look forward to. If you want to try again, you’re more than welcome to do so, but we highly doubt you’ll make it.',
                        'Hey! Yes, you. Didn’t the cave you spent the last 50 years in have WiFi? You could try again but to be honest, it seems that the One Direction you’re heading is down.'
                    ];

                    var resultTextPart = this.shuffle(text);
                    this.resultText = resultTextPart[0];

                } else if(this.resultProcent > 40 && this.resultProcent <= 70) {

                    if(this.resultProcent > 55 && this.resultProcent < 56) {
                        this.resultProcent = 55;
                    }

                    ga('send', 'event', 'Quiz View Badges', 'click', 'mainstreamer');

                    this.continueApplication = false;
                    this.badge = 'mainstreamer';

                    var text = [
                        'Close but no cigar. You know your way around mainstream but only dead fish float. Maybe if you go beyond the car radio for once and widen your perspective you might have a shot. But try again and you might get it next time.',
                        'You almost passed, but no, almost doesn’t count. Playing in this league, you might need to practice your clicking skills to break free from the Top 50 chart. Remember, you don’t need to get a radio implant to expand your music listening but you’re welcome to give the quiz another go anyhow.'
                    ];

                    var resultTextPart = this.shuffle(text);
                    this.resultText = resultTextPart[0];

                } else if(this.resultProcent > 70 && this.resultProcent <= 80) {

                    ga('send', 'event', 'Quiz View Badges', 'click', 'toplister');
                    this.continueApplication = true;
                    this.badge = 'toplister';

                    var text = [
                        'Yes, you made it to the next level! You’re a trustful co-quizzer, but knowing the best-of everything doesn’t take you to the top immediately. So stay away from Shazam, sharpen your ears and step forward.',
                        'You passed, but just barely. Sure you listen to Billboard top 100 and might flip through Pitchfork every now and then, but to get this job you need to prove yourself. So move on to the next step and impress us.'
                    ];

                    var resultTextPart = this.shuffle(text);
                    this.resultText = resultTextPart[0];



                } else if(this.resultProcent > 80 && this.resultProcent <= 90) {


                    ga('send', 'event', 'Quiz View Badges', 'click', 'playlistprotege');
                    this.continueApplication = true;
                    this.badge = 'playlistprotege';

                    var text = [
                        'Nice, you’ve got the vibe! You might be an aspiring mixtape master with DJ dreams and probably have a soundtrack for anything from a housewarming party to your pet’s funeral. Please continue to the next level and impress our team.',
                        'You’ve got potential. Your Soundcloud-stream is your daily go-to place and you probably don’t hesitate to take over the music at the party, stating that your playlist is ”better than puppies and ice cream”. You might be the one for us, so move on to the next step and let’s see what you can do.'
                    ];

                    var resultTextPart = this.shuffle(text);
                    this.resultText = resultTextPart[0];



                } else if(this.resultProcent > 90 && this.resultProcent <= 95) {

                    ga('send', 'event', 'Quiz View Badges', 'click', 'musicgenius');

                    this.continueApplication = true;
                    this.badge = 'musicgenius';

                    var text = [
                        'Oh, impressive! Your cassette collection could probably pay off your student loans. Considering that it might also be organized in autobiographical order, it’s highly likely that you’ve got just what it takes. Please move on to the next step.',
                        'Wow, you’re good. Your vinyl collection is probably impeccable and your playlists could be displayed at MOMA. You probably even listened to Nirvana back when they were called Pen Cap Chew. We could really use someone like you on our team so move on to the next step.'
                    ];

                    var resultTextPart = this.shuffle(text);
                    this.resultText = resultTextPart[0];



                } else if(this.resultProcent > 95 && this.resultProcent <= 100 || this.resultProcent > 100) {

                    ga('send', 'event', 'Quiz View Badges', 'click', 'legend');


                    if(this.resultProcent > 100) {
                        this.resultProcent = 100;
                    }

                    this.continueApplication = true;
                    this.badge = 'legend';

                    var text = [
                        'You are the breed that makes insightful critics, talent scouts, record label execs, music journalists, record collectors, mix tape equilibrists and record store owners cry with envy. Nowadays, since all of these are things of the past, you will possibly make a great playlist curator.  And yes, you can make a good living from that as well!',
                        'Your expertise is as rare as a once-in-a-lifetime live unplugged set, recorded and posted on an obscure, invite-only blog, stream-ripped and pressed on an extremely limited edition white label bootleg vinyl 12” that is sold at an illegal underground club.',
                        'Holy crap! Where have you been all of our lives? You’re probably on a first name basis with Rick Rubin and Bono has you on speed dial. And was it true that Jay-Z and Beyonce asked you to be godfather to Blue Ivy? Please, please move on to the next step and apply!'
                    ];

                    var resultTextPart = this.shuffle(text);
                    this.resultText = resultTextPart[0];



                } else {
                    this.continueApplication = false;
                }

                this.sendResult(this.resultText);
            }

            this.currentQuestion++;
            this.questionAnswered = false;

        },

        calcProcent: function (value) {
            return (value / this.questions.length) * 100;
        },

        answer: function (alternative) {

          if(this.questionAnswered) {
                return;
            }

            console.log(alternative);

            var self = this;
            this.running = false;


            $('#quizAnimate').animate({right:'6%'},300);

            $('.navbarline').css('width', '+=1.5px');


            this.question.userAnswer = alternative;
            // this.question.showAnswer = true;
            this.questionAnswered = true;
            this.singleBool = true;


            ga('send', 'event', 'Quiz View', 'click', 'Answered Question: ' + this.currentQuestion);

            if(this.question.userAnswer == this.question.answer) {

                if(!this.question.question) {
                    console.log(this.question.answer);
                    ga('send', 'event', 'Quiz View', 'click', 'Correct Music Answer: ' + this.question.answer);
                } else {
                    console.log(this.question.question);
                    ga('send', 'event', 'Quiz View', 'click', 'Correct Follow Question: ' + this.question.question);
                }

                this.correctAnswers++;
            }

            if(this.currentQuestion < 19) {
                if(this.question.type == 'followup') {
                   // console.log(this.currentQuestion);
                    this.loadSpotify(this.questions[this.currentQuestion + 1].song_id);

                    this.stopSong();
                }
                if(this.question.type == 'audio') {

                    setTimeout(function() {
                        $('.animateQuiz').animate({
                            opacity: 0
                        }, 600, function() {
                            setTimeout(function() {

                            }, 600);
                        });
                    }, 1500);

                    setTimeout(function () {
                        self.nextQuestion();
                    }, 3000);
                }
            }
        },

        loadSpotify: function (song_id) {
            spotify.getPreviewUrlFromId(song_id).then(function (preview_url) {
                this.loadSong(preview_url);
            }.bind(this));
        },

        loadSong: function (url) {
            console.log('[Quiz: loading song: ' + url + ']');
            this.audio.src = url;
            this.audio.play();
            this.audio.pause();
        },

        playSong: function () {
            console.log('[Quiz: playing song: ' + this.audio.src + ']');

            this.audio.play();
        },

        stopSong: function () {
            this.audio.pause();
            this.audio.currentTime = 0;
        },

        sendResult: function (resultText) {

            var procent = this.calcProcent(this.correctAnswers);

            var endProcent = procent + this.randomNr;

            service.sendQuizData(endProcent, resultText);

        },

        startQuiz: function () {

            ga('send', 'event', 'Quiz View', 'click', 'Start Quiz');

            this.quizStart = true;

            $('.navbarline').css('width', '23px');

            $('.quizwave').animate({
                left: "-=10%",
            }, 500, function() {

            });

            this.playSong();
            this.startTimer();
        },


        thejob: function () {

            ga('send', 'event', 'About', 'click', 'About');

            $('.socialQuiz').toggleClass('active');
            $('.btn').toggleClass('active');
            $('.formwrap').toggleClass('active');
            $('.animateQuiz').toggleClass('active');
            $('.closeopen').toggleClass('active');
            $('.aboutWrapper').toggleClass('active');
            $('.overlay').toggleClass('active');
            $('.startText').toggleClass('active');
            $('.quiztext').toggleClass('active');
            $('.aboutskew').toggleClass('active');
            $('.badgewrapper').toggleClass('active');
            $('.wave').toggleClass('active');
            $('.socialStart').toggleClass('active');
            $('.form').toggleClass('active');
            $('.aboutInnerWrap').toggleClass('active');

        },

        retry: function() {

            ga('send', 'event', 'Quiz View', 'click', 'Retry');

            location.reload();

           /* // Create audio player
            this.audio = new Audio();

            this.questions = service.getQuestions();

            for(var i = 0; i < this.questions.length; i++) {
               this.shuffle(this.questions[i].alternatives);
            }

            // Get the preview_url for a certain song
            spotify.getPreviewUrlFromId(this.question.song_id).then(function (preview_url) {
                this.loadSong(preview_url);
            }.bind(this));


            this.audio = null;
            this.questions = [];
            this.totalTime = 0;
            this.currentQuestion = 0;
            this.currentBundleQuestion = 0;
            this.correctAnswers = 0;
            this.resultProcent = 0;
            this.questionAnswered = false;
            this.view = 'setup';
            this.quizStart = false;
            this.continueApplication = false;
            this.currentQuestionTime = null;
            this.timesUp = false;
            this.running = false;
            this.startTime = null;
            this.currentTime = null;
            this.showRightAnswer = false;
            this.badge = null;
            this.singleBool = false;
            this.resultText = 0;

            this.quizStart = false;
            this.view = 'question'; */

        },

        shuffle: function(array) {

        var currentIndex = array.length, temporaryValue, randomIndex ;

        while (0 !== currentIndex) {

            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
          }

          return array;
        }

    },
    ready: function () {
            // Create audio player
            this.audio = new Audio();

            this.questions = service.getQuestions();

            for(var i = 0; i < this.questions.length; i++) {
               this.shuffle(this.questions[i].alternatives);
            }

            // Get the preview_url for a certain song
            spotify.getPreviewUrlFromId(this.question.song_id).then(function (preview_url) {
                this.loadSong(preview_url);
            }.bind(this));
    },
    route: {
        data: function (transition) {
            // Get info from ajax call
            setTimeout(function () {
                transition.next({view: 'question'});
            }, 1);
        }
    }
}


